<div class="wrapper mb-5">
    <div class="row title-container align-items-center mb-5" style="padding: 10px;">
        <img src="./assets/icons/arrow-left.svg" style="margin-right: 10px; cursor: pointer;" (click)="back()">
        <img src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3"> Grupo {{ group.name }}</span>
    </div>
    <div class="form-card mt-5">
        <span class="subtitle-gray">Nome do grupo</span>
        <div class="center-no-padding">
            <span class="group-title">{{ group.name }}</span>
            <img class="ml-3 edit" src="./assets/icons/editar.svg" (click)="editarGrupo(editarGrupoModal, group)">
        </div>
        <span class="subtitle-gray">Descrição</span>
        <span class="group-description">{{ group.description }}</span>
        <span class="subtitle-gray mt-3">Produtos ({{productsByGroup == undefined ? '-' : productsByGroup.length}})</span>
        <div *ngFor="let item of productsByGroup" class="align-center">
            <div class="mr-4 card-icon">
                <app-svg-card [color]="item.productColor" [icon]="item.productIcon" [name]="item.productName"></app-svg-card>
            </div>
            <!--img class="mr-4 card-icon" src="./assets/icons/produtos/icon-produtos/{{item.productGuid}}.svg" onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';"-->
            <div class="row-mobile">
                <span class="benefit-data">{{ item.productName }}</span>
                <div class="dot"></div>
            </div>
            <div class="row-mobile">
                <span *ngIf="item.standardPeriodCard === 1" class="benefit-data">Mensal</span>
                <span *ngIf="item.standardPeriodCard === 2" class="benefit-data">Diário</span>
                <div class="dot"></div>
            </div>
            <div class="row-mobile">
                <div class="benefit-data">{{ item.value | currency: 'R$' }}</div>
                <img class="ml-3 edit" src="./assets/icons/editar.svg" (click)="editarProdutosGrupo(editarProdutosGrupoModal, item)">
            </div>
        </div>
        <div class="separador mt-4 mb-4"></div>
        <div class="row mt-2 align-center d-flex justify-content-center">
            <button (click)="editarCesta()" class="white-button col-5">Editar produtos</button>
            <button (click)="visualizar()" class="white-button col-5">Visualizar favorecidos</button>
            <button (click)="novo()" class="action-button col-5">Novo favorecido</button>
            <button (click)="adicionar()" class="action-button col-5">Adicionar favorecidos existentes</button>
        </div>
    </div>
</div>

<ng-template #editarGrupoModal let-modal>
    <div class="col-12" style="margin-right: 15px;">
        <button id="buttonCloseModal" type="button" class="btn right" style="background-color: #fff; border: none;" (click)="modal.dismiss()">
            <img src="./assets/icons/X.png">
        </button>
    </div>
    <div class="form-card mt-5">
        <label for="group-name">Nome do grupo*</label>
        <input type="text" id="group-name" [(ngModel)]="newGroupName" placeholder="Nome do grupo">
        <span class="hint mt-2">Exemplo: Gerência, Supervisores, Estagiários...</span>
        <label class="mt-4" for="group-description">Descrição</label>
        <input type="text" id="group-description" [(ngModel)]="newGroupDescription" placeholder="Descrição">
        <button (click)="next()" class="action-button mt-5">Próximo</button>
    </div>
</ng-template>

<ng-template #editarProdutosGrupoModal let-modal>
    <div class="col-12" style="margin-right: 15px;">
        <!--[disabled]="inInvalidMaxValue"  -->
        <button id="buttonCloseModal" type="button" class="btn right" style="background-color: #fff; border: none;" (click)="modal.dismiss()">
            <img src="./assets/icons/X.png">
        </button>
    </div>
    <div class="form-card mt-5">
        <span class="subtitle">Configure o produto</span>
        <div class="mt-2 grid-line">
            <div class="quarter">
                <div class="frame">
                    <!-- <img class="white" src="./assets/icons/grupos/beneficios_temp/alimentacao.svg">  -->
                    <!-- ./assets/icons/produtos/icon-produtos/{{this.selectedItem.productGuid}}.svg -->
                    <span class="label-beneficio mt-3">{{this.selectedItem.productName}}</span>
                </div>
            </div>
            <div class="quarter grid-rows">
                <div class="flex-center mb-4 space-between">
                    <div class="flex-center">
                        <input [attr.id]="selectedItem.standardPeriodCard" type="radio" class="rdButton" [(ngModel)]="standardPeriodType" id="mensal" name="tipo" value="mensal">
                        <label [attr.for]="selectedItem.standardPeriodCard">Mensal</label>
                    </div>
                    <div class="flex-center">
                        <input [attr.id]="standardPeriodType" type="radio" class="rdButton" [(ngModel)]="standardPeriodType" id="diario" name="tipo" value="diario">
                        <label [attr.for]="standardPeriodType">Diário</label>
                    </div>

                </div>
                <div class="col p-0">
                    <label for="valor-beneficio">Valor:</label>
                    <input name="valor-beneficio" id="valor-beneficio" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" [(ngModel)]="valorBeneficio" class="input-value" placeholder="R$ 0,00">
                    <span class="invalid-feedback" *ngIf="inInvalidMaxValue">
                        {{messageMaxValueInvalid}}
                    </span>
                </div>
            </div>
        </div>
        <button (click)="updateProduct()" class="action-button mt-5">Próximo</button>
    </div>
</ng-template>
